export default "__VITE_ASSET__ClThY0rr__"